var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutoriaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.7 33",
    style: {
      enableBackground: "new 0 0 228.7 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.1,26.5c0,0-2.9,0.2-4.4-4.2c4-1.5,6.9-5.3,6.9-9.9c0-5.8-4.7-10.5-10.5-10.5h-10.6 c-3.2,0-5.9,2.6-5.9,5.9v8.6V23v7c0,1.7,1.3,3,3,3s3-1.3,3-3v-7h8c2.1,7.5,7.3,9.5,10.4,9.5c0.2,0,0.4,0,0.6,0 c1.6-0.1,2.9-1.6,2.7-3.2S172.8,26.4,171.1,26.5z M152.6,16.5V8h10.5c2.5,0,4.5,2,4.5,4.5s-2,4.5-4.5,4.5h-10.5V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,0L17.2,0L17.2,0L17.2,0C11.2,0,5.4,2.3,1,6.4c-1.2,1.1-1.3,3-0.2,4.2c1.1,1.2,3,1.3,4.2,0.2 c2.6-2.4,5.8-3.9,9.2-4.5V30c0,1.7,1.3,3,3,3s3-1.3,3-3V6.3c3.4,0.6,6.6,2.1,9.2,4.5c0.6,0.5,1.3,0.8,2,0.8c0.8,0,1.6-0.3,2.2-1 c1.1-1.2,1.1-3.1-0.2-4.2C29.1,2.3,23.3,0,17.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89,0L89,0L89,0L89,0C83,0,77.2,2.3,72.8,6.4c-1.2,1.1-1.3,3-0.2,4.2c1.1,1.2,3,1.3,4.2,0.2 c2.6-2.4,5.8-3.9,9.2-4.5V30c0,1.7,1.3,3,3,3s3-1.3,3-3V6.3c3.4,0.6,6.6,2.1,9.2,4.5c0.6,0.5,1.3,0.8,2,0.8c0.8,0,1.6-0.3,2.2-1 c1.1-1.2,1.1-3.1-0.2-4.2C100.9,2.3,95.1,0,89,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.1,2c-1.7,0-3,1.3-3,3v15.1c0,3.2-3.1,5.9-7,5.9s-7-2.6-7-5.9V5c0-1.7-1.3-3-3-3s-3,1.3-3,3v15.1 c0,6.6,5.8,11.9,13,11.9s13-5.3,13-11.9V5C66.1,3.4,64.8,2,63.1,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.9,2c-8.3,0-15,6.7-15,15s6.7,15,15,15s15-6.7,15-15S133.2,2,124.9,2z M124.9,26c-5,0-9-4-9-9s4-9,9-9 c5,0,9,4,9,9S129.9,26,124.9,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.5,2c-1.7,0-3,1.3-3,3v24c0,1.7,1.3,3,3,3s3-1.3,3-3V5C188.5,3.4,187.2,2,185.5,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.4,28.6L216.1,5c-0.7-1.3-1.9-2-3.4-2s-2.7,0.8-3.4,2L197,28.6c-0.8,1.5-0.2,3.3,1.3,4.1 c1.5,0.8,3.3,0.2,4.1-1.3l2.3-4.4c2.1-2.3,5-3.6,8.1-3.6s6,1.3,8.1,3.6l2.3,4.4c0.5,1,1.6,1.6,2.7,1.6c0.5,0,0.9-0.1,1.4-0.3 C228.6,31.9,229.1,30.1,228.4,28.6z M212.7,17.4c-1.1,0-2.2,0.1-3.2,0.3l3.2-6.2l3.2,6.2C214.9,17.5,213.8,17.4,212.7,17.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutoriaLogo);
export default __webpack_public_path__ + "static/media/tutoria-logo.fb7723df829b16ed0fb71d2864131632.svg";
export { ForwardRef as ReactComponent };